import * as Mod1 from "./lib/discourse-markdown/bbcode-color";
const compatModules = {
  "lib/discourse-markdown/bbcode-color": Mod1,
};
export { compatModules };
export default compatModules;
